<template>
  <base-slide-over ref="slideover" :title="isNew === true ? 'New Medication' : 'Edit Medication'" size="xl" style="z-index: 10000">
    <base-form ref="productForm" class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" v-model="isFormValid">
      <base-text-field label="Medication Name" placeholder="Enter product name" v-model="businessItemCategory.name" class="tw-mt-3" required :maxLength="255" />
      <base-text-field
        label="Short Description"
        placeholder="Enter a short description of the medication"
        v-model="businessItemCategory.descriptionShort"
        class="tw-mt-2"
        required
        :maxLength="255"
      />
      <base-textarea
        label="Long Description"
        placeholder="Enter a longer description of the medication"
        v-model="businessItemCategory.descriptionLong"
        class="tw-mt-3"
        required
        :maxLength="1020"
      />
      <base-text-field label="Base Medication Name" placeholder="Enter product base name" v-model="businessItemCategory.baseName" class="tw-mt-4" :maxlength="255" />
      <base-text-field
        label="Medication Strength"
        placeholder="Enter Strength e.g., for 0.1%, 5mg, 2500mcg."
        v-model="businessItemCategory.strength"
        class="tw-mt-4"
        :maxlength="255"
      />
      <base-text-field label="Quantity" placeholder="Enter total quantity to dispense" v-model="businessItemCategory.quantity" class="tw-mt-5" type="number" />
      <base-text-field label="Quantity Unit" placeholder="Enter unit (e.g.'mL', 'Ct.')" v-model="businessItemCategory.quantityUnit" class="tw-mt-6" :maxlength="50" />
      <base-textarea label="SIG (Directions)" placeholder="Enter directions for use" v-model="businessItemCategory.sig" class="tw-mt-7" />
      <base-text-field label="Days Supply" placeholder="Enter days supply" v-model.number="businessItemCategory.daysSupply" class="tw-mt-8" type="number" />
      <base-text-field label="Refills" placeholder="Enter number of refills" v-model.number="businessItemCategory.refills" class="tw-mt-9" type="number" />
      <base-text-field label="Medication Form" placeholder="Enter product Form" v-model="businessItemCategory.form" class="tw-mt-4" :maxlength="255" />

      <base-select label="Medication Group" placeholder="Select a group" :options="productGroups" v-model="businessItemCategory.productGroup" class="tw-mt-10" />
      <base-text-field
        v-if="businessItemCategory.productGroup === 'new group'"
        label="New Medication Group"
        placeholder="Enter new medication group"
        v-model="businessItemCategory.newProductGroup"
        :rules="[() => (this.businessItemCategory.productGroup === 'new group' && this.businessItemCategory.newProductGroup !== null) || 'Please enter a new group name']"
        :maxLength="255"
        class="tw-mt-10"
      />
      <!-- additional for supported pharmacy -->
      <base-text-field label="Everwell Product Id" placeholder="Enter everwell product id " v-model="businessItemCategory.apiProductId" class="tw-mt-5" :maxLength="255" />

      <base-text-field label="Innovation Product Id" placeholder="Enter Innovation product id " v-model="businessItemCategory.lfProductId" class="tw-mt-5" :maxLength="255" />
      <base-text-field label="RPC2B Product Id" placeholder="Enter RPC2B product id " v-model="businessItemCategory.rpc2bProductId" class="tw-mt-5" :maxLength="255" />

      <base-text-field label="NDC Code" placeholder="Enter NDC code " v-model="businessItemCategory.ndcCode" class="tw-mt-5" :maxLength="255" />

      <base-radio-group :value="businessItemCategory.status" class="tw-mt-3 tw-space-x-6 tw-flex" required>
        <base-radio value="active" name="status" v-model="businessItemCategory.status">Active</base-radio>
        <base-radio value="inactive" name="status" v-model="businessItemCategory.status">Inactive</base-radio>
        <base-radio value="archived" name="status" v-model="businessItemCategory.status">Archived</base-radio>
      </base-radio-group>
    </base-form>
    <inline-error id="business-plan-error" :title="errorTitle" :message="errorMessage" :error="error" />
    <template #fixed-bottom>
      <div class="tw-py-2 tw-px-3 tw-flex tw-justify-end">
        <base-button type="flat" class="tw-w-auto tw-mr-3" @click="close()">
          Cancel
        </base-button>
        <base-button :loading="isSaving" :disabled="!isFormValid" class="tw-w-auto" @click="save">
          Save
        </base-button>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import { mapGetters } from "vuex";
import InlineError from "@/components/InlineError";

export default {
  name: "BusinessMedicationSlideover",
  components: { InlineError },
  data() {
    return {
      isFormValid: true,
      isSaving: false,
      isNew: false,
      businessId: null,
      businessItemCategory: {
        businessId: null,
        businessItemCategoryId: null,
        name: null,
        descriptionShort: null,
        descriptionLong: null,
        retailPriceCurrency: "USD",
        retailPriceCents: 0,
        retailPrice: 0, // This seems to be a display field, retailPriceCents is what's sent to API
        status: "active",
        type: "medication",
        productGroup: null,
        newProductGroup: null,
        taxable: false,
        baseName: null,
        strength: null,
        quantity: null,
        quantityUnit: null,
        sig: null,
        daysSupply: null,
        refills: null,
        form: null,
        apiProductId: null, // EverWell Product Id
        lfProductId: null, // LifeFile Product Id
        rpc2bProductId: null, // RPC2B Product Id
        ndcCode: null, // NDC Code
      },
      productGroups: [],
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
  },
  methods: {
    reset() {
      this.isNew = false;
      this.businessId = null;
      this.businessItemCategory = {
        businessId: null,
        businessItemCategoryId: null,
        name: null,
        descriptionShort: null,
        descriptionLong: null,
        retailPriceCurrency: "USD",
        retailPriceCents: 0,
        retailPrice: 0,
        status: "active",
        type: "medication",
        productGroup: null,
        newProductGroup: null,
        taxable: false,
        baseName: null,
        strength: null,
        quantity: null,
        quantityUnit: null,
        sig: null,
        daysSupply: null,
        refills: null,
        form: null,
        apiProductId: null, // EverWell Product Id
        lfProductId: null, // LifeFile Product Id
        rpc2bProductId: null, // RPC2B Product Id
        ndcCode: null, // NDC Code
      };
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
    },
    show(businessId, businessItemCategory, productGroups) {
      this.reset();
      this.businessId = businessId;
      this.productGroups = productGroups;

      if (!businessItemCategory) this.isNew = true;
      if (businessItemCategory) {
        this.businessItemCategory.businessId = businessId;
        this.businessItemCategory.businessItemCategoryId = businessItemCategory.businessItemCategoryId;
        this.businessItemCategory.name = businessItemCategory.name;
        this.businessItemCategory.descriptionShort = businessItemCategory.descriptionShort;
        this.businessItemCategory.descriptionLong = businessItemCategory.descriptionLong;
        this.businessItemCategory.retailPriceCurrency = businessItemCategory.retailPriceCurrency;
        this.businessItemCategory.retailPrice = businessItemCategory.retailPriceCents;
        this.businessItemCategory.status = businessItemCategory.status;
        this.businessItemCategory.type = businessItemCategory.type;
        this.businessItemCategory.productGroup = businessItemCategory.productGroup;
        this.businessItemCategory.taxable = businessItemCategory.taxable;
        this.businessItemCategory.baseName = businessItemCategory.baseName;
        this.businessItemCategory.strength = businessItemCategory.strength;
        this.businessItemCategory.quantity = businessItemCategory.quantity;
        this.businessItemCategory.quantityUnit = businessItemCategory.quantityUnit;
        this.businessItemCategory.sig = businessItemCategory.sig;
        this.businessItemCategory.daysSupply = businessItemCategory.daysSupply;
        this.businessItemCategory.refills = businessItemCategory.refills;
        this.businessItemCategory.form = businessItemCategory.form;
        this.businessItemCategory.apiProductId = businessItemCategory.apiProductId; // EverWell Product Id
        this.businessItemCategory.lfProductId = businessItemCategory.lfProductId; // LifeFile Product Id
        this.businessItemCategory.rpc2bProductId = businessItemCategory.rpc2bProductId; // RPC2B Product Id
        this.businessItemCategory.ndcCode = businessItemCategory.ndcCode; // NDC Code
      }

      this.$refs.slideover.show();
    },
    close() {
      this.$refs.slideover.hide();
    },
    save() {
      this.isSaving = true;
      if (!this.$refs.productForm.validate()) {
        this.isSaving = false; // Stop saving if form is invalid
        return;
      }

      const commonPayload = {
        businessId: this.businessId, // For POST, or could be used in PUT if needed by API
        name: this.businessItemCategory.name,
        descriptionShort: this.businessItemCategory.descriptionShort,
        descriptionLong: this.businessItemCategory.descriptionLong,
        retailPriceCurrency: this.businessItemCategory.retailPriceCurrency,
        retailPriceCents: this.businessItemCategory.retailPriceCents,
        status: this.businessItemCategory.status,
        taxable: this.businessItemCategory.taxable,
        type: this.businessItemCategory.type,
        productGroup: this.businessItemCategory.newProductGroup !== null ? this.businessItemCategory.newProductGroup : this.businessItemCategory.productGroup,
        baseName: this.businessItemCategory.baseName,
        strength: this.businessItemCategory.strength,
        quantity: this.businessItemCategory.quantity,
        quantityUnit: this.businessItemCategory.quantityUnit,
        sig: this.businessItemCategory.sig,
        daysSupply: this.businessItemCategory.daysSupply,
        refills: this.businessItemCategory.refills,
        form: this.businessItemCategory.form,
        apiProductId: this.businessItemCategory.apiProductId, // EverWell Product Id
        lfProductId: this.businessItemCategory.lfProductId, // LifeFile Product Id
        rpc2bProductId: this.businessItemCategory.rpc2bProductId, // RPC2B Product Id
        ndcCode: this.businessItemCategory.ndcCode, // NDC Code
      };

      if (this.isNew) {
        this.$axios
          .post(`/businesses/${this.businessId}/item-categories`, commonPayload)
          .then(() => {
            this.close();
            this.$emit("save");
            this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Medication Added", message: "Medication " + this.businessItemCategory.name + " was created successfully" });
          })
          .catch((err) => {
            this.errorTitle = `Failed to create ${this.businessItemCategory.name}`;
            this.errorMessage = `Medication ${this.businessItemCategory.name} was not able to be created. Please try again.`;
            this.error = err;
          })
          .finally(() => {
            this.isSaving = false;
          });
      } else {
        // For PUT, include businessItemCategoryId in the payload as well
        const putPayload = {
          ...commonPayload, // Spread the common fields
          businessItemCategoryId: this.businessItemCategory.businessItemCategoryId,
        };
        this.$axios
          .put(`/businesses/${this.businessId}/item-categories/${this.businessItemCategory.businessItemCategoryId}`, putPayload)
          .then(() => {
            this.close();
            this.$emit("save");
            this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Medication Updated", message: "Medication " + this.businessItemCategory.name + " was updated successfully" });
          })
          .catch((err) => {
            this.errorTitle = `Failed to update ${this.businessItemCategory.name}`;
            this.errorMessage = `Medication ${this.businessItemCategory.name} was not able to be updated. Please try again.`;
            this.error = err;
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    },
  },
};
</script>
